module.exports = __webpack_public_path__ + "img/eLong@2x.c0812d64.png";